<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h4>Detil Transaksi</h4>
        <div class="trxCnt" v-if="d">
          <div class="trxItemCnt">
            <div class="trxItem big">
              <span>No. Transaksi</span>
              {{d.orderNo}}
            </div>
            <div class="trxItem">
              <span>Status Transaksi</span>
              <b class="status" :class="d.status">{{d.status}}</b>
            </div>
            <div class="trxItem">
              <span>Tanggal Transaksi]</span>
              {{d.orderDate | moment('DD/MM/YYYY HH:MM')}}
            </div>
            <div class="trxItem">
              <span>No. Pembayaran</span>
              <template v-if="d.trxNo">{{d.trxNo}}</template>
              <template v-else>-</template>
            </div>
            <div class="trxItem">
              <span>Kurir</span>
              <template v-if="d.courier">
                {{d.courier.name}}
                <template v-if="d.courier.cost">
                  {{d.courier.cost.service}}
                  <template v-if="d.courier.cost.cost
                    && d.courier.cost.cost.length > 0">
                    - ETD {{d.courier.cost.cost[0].etd}}
                  </template>
                </template>
              </template>
              <template v-else>-</template>
            </div>
            <div class="trxItem">
              <span>Ongkos Kirim</span>
              <template v-if="d.shippingCost">Rp {{d.shippingCost.toLocaleString('id')}}</template>
              <template v-else>-</template>
            </div>
            <div class="trxItem">
              <span>Asuransi Pengiriman</span>
              <template v-if="d.useDeliveryInsurance === 1">
                <template v-if="d.deliveryInsuranceFee">
                  {{d.deliveryInsuranceFee.toLocaleString('id')}}</template>
                <template v-else>-</template>
              </template>
              <template v-else>Tanpa asuransi</template>
            </div>
            <div class="trxItem">
              <span>Tanggal Pengiriman</span>
              <template v-if="d.deliveryDate">
                {{d.deliveryDate | moment('DD/MM/YYYY HH:MM')}}
              </template>
              <template v-else>-</template>
            </div>
            <div class="trxItem">
              <span>Kode Tracking Pengiriman</span>
              <template v-if="d.courierTrackingCode">{{d.courierTrackingCode}}</template>
              <template v-else>-</template>
            </div>
            <div class="trxItem">
              <span>Catatan</span>
              <template v-if="d.customerNotes">{{d.customerNotes}}</template>
              <template v-else>-</template>
            </div>
            <div class="trxItem">
              <span>Metode Pembayaran</span>
              <template v-if="d.paymentMethod">{{d.paymentMethod}}</template>
              <template v-else>-</template>
            </div>
            <template v-if="d.paymentMethod === 'Virtual Account'">
              <div class="trxItem">
                <span>VA Bank</span>
                <template v-if="d.vaBank">{{d.vaBank}}</template>
                <template v-else>-</template>
              </div>
              <div class="trxItem" v-if="d.vaCode">
                <span>Biller Code</span>
                <template v-if="d.vaCode">{{d.vaCode}}</template>
                <template v-else>-</template>
              </div>
              <div class="trxItem" v-if="d.vaNumber">
                <span>VA Number</span>
                <template v-if="d.vaNumber">{{d.vaNumber}}</template>
                <template v-else>-</template>
              </div>
            </template>
            <template v-if="d.paymentMethod === 'Retail Store'">
              <div class="trxItem">
                <span>Retail Store</span>
                <template v-if="d.retailProvider">{{d.retailProvider}}</template>
                <template v-else>-</template>
              </div>
              <div class="trxItem">
                <span>Store Payment Code</span>
                <template v-if="d.retailPaymentCode">{{d.retailPaymentCode}}</template>
                <template v-else>-</template>
              </div>
            </template>
            <div class="trxItem" v-if="d.maskedCard">
              <span>Card Number</span>
              {{d.maskedCard}}
            </div>
            <div class="trxItem">
              <span>Donasi</span>
              <template v-if="d.withDonation === 1">
                <template v-if="d.withDonation === 1">
                  {{d.donationAmount.toLocaleString('id')}}</template>
                <template v-else>-</template>
              </template>
              <template v-else>Tanpa Donasi</template>
            </div>
          </div>
          <div class="productCnt" v-if="d.products && d.products.length > 0">
            <h4 class="sectionTitle">Products</h4>
            <div class="productItem" v-for="(item, i) in d.products" :key="`prd${i}`">
              <div class="productImg" v-if="item.product.images.length > 0
                && item.product.images[0].media"
                :style="{'background-image': `url(${item.product.images[0].media.imageSm})`}">
              </div>
              <div class="productImg noImg" v-else></div>
              <div class="productInfo">
                <h4>{{item.product.name}}</h4>
                <div class="variantCnt" v-if="item.variants.length > 0">
                  <div class="variant" v-for="(v, i) in item.variants"
                    :key="`v${i}`" :class="{color: v.color && v.color !== '#EEEEEE'}">
                    <div class="color" :style="{'background-color': v.color}"
                      v-if="v.color && v.color !== '#EEEEEE'"></div>
                    <span>{{v.label}}:</span>{{v.value}}
                  </div>
                </div>
                <p><template v-if="item.product.discountedPrice">
                  <strike>Rp {{item.product.sellPrice.toLocaleString('id')}}</strike>
                  Rp {{item.product.discountedPrice.toLocaleString('id')}}</template>
                  <template v-else-if="item.product.sellPrice">
                  Rp {{item.product.sellPrice.toLocaleString('id')}}</template>
                  <template v-else>Rp 0</template>/item <span class="bull">&bull;</span>
                  Qty: {{item.qty.toLocaleString('id')}}</p>
              </div>
              <div class="subtotal" v-if="item.subtotal">
                Rp {{item.subtotal.toLocaleString('id')}}</div>
            </div>
          </div>
          <div class="shippingAddress" v-if="d.address">
            <h4 class="sectionTitle">Alamat Pengiriman</h4>
            <div class="addrCnt">
              <p><b>{{d.address.recipient}}
                <span v-if="d.address.phone">({{d.address.phone}})</span></b><br />
                {{d.address.userAddress}}
                <span v-if="d.address.rtrw">, RT/RW {{d.address.rtrw}}</span><span
                v-if="d.address.subDistrict">, Desa {{d.address.subDistrict}}</span><span
                v-if="d.address.district">, Kec. {{d.address.district}}</span><span
                v-if="d.address.cityName">, Kota {{d.address.cityName}}</span><span
                v-if="d.address.provinceName">, Provinsi {{d.address.provinceName}}</span><span
                v-if="d.address.postalCode"> - {{d.address.postalCode}}</span></p>
            </div>
          </div>
          <div class="paymentInfo">
            <h4 class="sectionTitle">Payment Information</h4>
            <div class="paymentItem" v-if="subtotal">
              Subtotal
              <span>Rp {{subtotal.toLocaleString('id')}}</span>
            </div>
            <div class="paymentItem discount" v-if="totalDiscount">
              Total discount
              <span>-Rp {{totalDiscount.toLocaleString('id')}}</span>
            </div>
            <div class="paymentItem discount" v-if="promoValue">
              Promo
              <template v-if="d.promo && d.promo.promoType === 'private' && d.promo.code">
                ({{d.promo.code}})</template>
              <template v-else-if="d.promo && d.promo.promoType === 'public'">
                ({{d.promo.name}})</template>
              <span>-Rp {{promoValue.toLocaleString('id')}}</span>
            </div>
            <div class="paymentItem" v-if="taxValue">
              Pajak
              <span>Rp {{taxValue.toLocaleString('id')}}</span>
            </div>
            <div class="paymentItem" v-if="d.withDonation === 1
              && d.donationAmount ">
              Donation <template v-if="d.donationName">{{d.donationName}}</template>
              <span>Rp {{d.donationAmount.toLocaleString('id')}}</span>
            </div>
            <div class="paymentItem" v-if="d.shippingCost">
              Ongkos kirim <template v-if="d.courier">
                ({{d.courier.name}})</template>
              <span>Rp {{d.shippingCost.toLocaleString('id')}}</span>
            </div>
            <div class="paymentItem">
              Grand Total
              <span>Rp {{d.grandTotal.toLocaleString('id')}}</span>
            </div>
          </div>
          <div class="trxTimeline" v-if="d.timeline && d.timeline.length > 0">
            <h4 class="sectionTitle">Riwayat Transaksi</h4>
            <div class="tlCnt">
              <div class="tlItem" v-for="(tl, i) in d.timeline" :key="`tl${i}`">
                <div class="tlLeft">
                  {{tl.timestamp | moment('DD')}}<span>{{tl.timestamp | moment('MMM')}}</span>
                </div>
                <div class="tlRight">
                  <div class="tlDate">{{tl.timestamp | moment('dddd, DD MMM YYYY HH:MM')}}</div>
                  <h4>{{tl.title}}</h4>
                  <p v-if="tl.description">{{tl.description}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      show: false,
      next: null,
      d: null,

      /**
       * Price
       *
       */
      subtotal: 0,
      totalDiscount: 0,
      promoValue: 0,
      taxValue: 0,
    };
  },
  methods: {
    open(d, n) {
      this.loading = false;
      this.next = n;
      this.show = true;
      this.d = d;
      this.calcPrice();
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    calcPrice() {
      this.subtotal = 0;
      this.totalDiscount = 0;
      // eslint-disable-next-line
      for (const item of this.d.products) {
        this.subtotal += item.product.sellPrice * item.qty;
        this.totalDiscount += (item.product.sellPrice - item.product.discountedPrice) * item.qty;
      }

      if (this.d.promo) {
        if (this.d.promo.minPurchase && this.d.promo.minPurchase > this.d.totalProductPrice) {
          this.d.promo = null;
        } else {
          this.promoValue = (this.d.promo.discountType === 'fixed')
            ? this.d.promo.amount : this.d.totalProductPrice * this.d.promo.percentage / 100;
          if (this.d.promo.max && this.promoValue > this.d.promo.max) {
            this.promoValue = this.d.promo.max;
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 720px;
    margin: auto;
    border-radius: 5px;
    padding: 30px 0 20px;
    overflow: hidden;
    transition: all .3s ease;
    @media (max-width: 760px) {
      width: calc(100% - 20px);
    }
    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4{
      font-size: 24px;
      font-weight: 600;
      margin: 0 80px 20px;
      @media (max-width: 680px) {
        margin: -10px 32px 14px;
        font-size: 20px;
      }
    }
    .btnCnt{
      text-align: right;
      border-top: #eee 1px solid;
      margin: 0 -80px -40px;
      padding: 12px 30px 2px;
    }
    .btn{
      margin-left: 5px;
      margin-bottom: 10px;
      &.saving{
        background-color: #ccc;
        color: #999;
        cursor: default;
        box-shadow: none;
      }
    }
    .trxCnt{
      border-top: #eee 1px solid;
      border-bottom: #eee 1px solid;
      max-height: calc(100vh - 240px);
      overflow-y: auto;
      padding: 10px 80px 0;
      box-sizing: border-box;
      @media (max-width: 680px) {
        padding: 10px 32px;
      }
      .trxItemCnt{
        // display: flex;
        // flex-wrap: wrap;
        // margin: 0 -20px;
        margin-bottom: 40px;
        .trxItem{
          // width: 50%;
          display: flex;
          padding: 10px 0 8px;
          box-sizing: border-box;
          position: relative;
          font-size: 16px;
          align-items: center;
          text-align: right;
          border-bottom: #ccc 1px dashed;
          @media (max-width: 680px) {
            font-size: 15px;
          }
          &:before{
            content: "";
            position: absolute;
            left: 20px; right: 20px; bottom: 0;
            height: 0; border-top: #ccc 1px dashed;
            display: none;
          }
          b.status{
            color: #444;
            position: relative;
            padding-left: 12px;
            margin-left: 16px;
            font-weight: 600;
            &:before{
              content: "";
              position: absolute;
              width: 12px; height: 12px;
              width: 5px; height: 16px;
              // border-radius: 50%;
              background-color: #ccc;
              border-radius: 50px;
              top: 50%; margin-top: -8px;
              left: 0;
            }
            &.Pending{
              color: #eb9a00;
              &:before{
                background-color: orange;
              }
            }
            &.Payment.Failed,
            &.Payment.Expired,
            &.Canceled{
              color: red;
              &:before{
                background-color: red;
              }
            }
            &.Processing,
            &.On.Delivery,
            &.Delivered{
              color: purple;
              &:before{
                background-color: purple;
              }
            }
            &.Payment.Verified{
              color: blue;
              &:before{
                background-color: blue;
              }
            }
            &.Completed{
              color: green;
              &:before{
                background-color: green;
              }
            }
          }
          span{
            color: #767676;
            margin-right: auto;
            display: block;
            margin-bottom: 2px;
            font-size: 15px;
            text-align: left;
            padding-right: 20px;
          }
          &.big{
            width: 100%;
            font-size: 24px;
            font-weight: 600;
            color: #035fae;
            @media (max-width: 680px) {
              font-size: 18px;
            }
            span{
              font-weight: normal;
              color: #767676;
            }
          }
        }
      }
      h4.sectionTitle{
        margin: 30px 0 10px;
        font-size: 20px;
      }
      .productCnt{
        margin-bottom: 48px;
        .productItem{
          position: relative;
          display: flex;
          margin-bottom: 20px;
          .productImg{
            width: 46px; height: 46px;
            background-color: #ccc;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 5px;
            margin-right: 14px;
            &.noImg{
              background-image: url(../assets/image-black.png);
              background-size: 20px auto;
              opacity: .36;
            }
          }
          .productInfo{
            h4{
              margin: 0 0 2px;
              font-size: 16px;
              font-weight: 600;
              @media (max-width: 680px) {
                font-size: 15px;
              }
            }
            .variantCnt{
              display: flex;
              flex-wrap: wrap;
              .variant{
                border-radius: 3px;
                border: #ddd 1px solid;
                padding: 2px 8px 3px;
                font-size: 14px;
                margin: 4px 8px 4px 0;
                font-weight: 600;
                position: relative;
                &.color{
                  padding-left: 26px;
                  .color{
                    width: 15px; height: 15px;
                    position: absolute;
                    left: 4px; top: 4px;
                    border-radius: 2px;
                  }
                }
                span{
                  color: #767676;
                  margin-right: 5px;
                  font-weight: 400;
                }
              }
            }
            p{
              margin: 0;
              color: #444;
              font-size: 14px;
              @media (max-width: 680px) {
                font-size: 13px;
              }
              strike{
                color: red;
                font-size: 12px;
              }
              .bull{
                margin: 0 6px;
              }
            }
          }
          .subtotal{
            margin-left: auto;
            font-size: 18px;
            font-weight: 600;
            @media (max-width: 680px) {
              font-size: 16px;
            }
          }
        }
      }
      .shippingAddress{
        margin-bottom: 48px;
        .addrCnt{
          p{
            margin: 0;
            // padding-right: 20px;
            line-height: 1.4;
            b{
              font-size: 18px;
              font-weight: 600;
            }
          }
          .btn{
            border: #0747a6 1px solid;
            font-weight: 500;
            border-radius: 5px;
            padding: 9px 20px 8px;
            font-size: 17px;
            margin: 0;
            margin-left: auto;
          }
        }
      }
      .paymentInfo{
        h4.sectionTitle{
          margin-bottom: 6px;
        }
        .paymentItem{
          border-bottom: #ccc 1px dashed;
          display: flex;
          padding: 10px 0;
          font-size: 16px;
          span{
            margin-left: auto;
            font-weight: 600;
          }
          &.discount{
            span{
              color: #0747a6;
            }
          }
        }
      }
      .trxTimeline{
        .tlCnt{
          position: relative;
          margin-top: 20px;
          &:before{
            content: "";
            position: absolute;
            left: 80px; top: -13px;
            width: 13px; height: 13px;
            background-color: #0747a6;
            border-radius: 50%;
            margin-left: -6px;
          }
          .tlItem{
            display: flex;
            .tlLeft{
              width: 80px;
              border-right: #eee 1px solid;
              text-align: center;
              font-weight: 600;
              font-size: 24px;
              text-transform: uppercase;
              position: relative;
              box-sizing: border-box;
              padding-top: 6px;
              &:before{
                content: "";
                position: absolute;
                right: -5px; top: 27px;
                width: 9px; height: 9px;
                background-color: #0747a6;
                border-radius: 50%;
              }
              span{
                display: block;
                font-size: 14px;
              }
            }
            .tlRight{
              width: calc(100% - 80px);
              box-sizing: border-box;
              padding-left: 20px;
              padding-bottom: 30px;
              .tlDate{
                color: #767676;
              }
              h4{
                margin: 3px 0;
                font-size: 17px;
              }
              p{
                margin: 0;
                font-size: 15px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
